var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"notice-table-box"},[_c('switch-other'),_c('table-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }